import { Component, OnInit } from '@angular/core';
import { MENUS_NAVBAR } from './navbar-menu.constant';
import { MENUS_INFOBAR } from './navbar-infobar-menu.constant';
import { AuthService } from '@core/services/auth.service';
import { StorageService } from '@core/services/storage.service';
import { FilterStateService } from '../../../../../shared/services/filter-state.service';
import { ReadaptacaoService } from '@core/services/readaptacao.service';

@Component({
  selector: 'app-navbar-auth',
  templateUrl: './navbar-auth.component.html',
  styleUrls: ['./navbar-auth.component.scss']
})
export class NavbarAuthComponent implements OnInit {
  public menus = MENUS_NAVBAR;
  public menusInfoBar = MENUS_INFOBAR;
  public usuarioSession: any;

  constructor(
    private readonly authService: AuthService,
    private readonly storageService: StorageService,
    private readonly filterStateService: FilterStateService,
    private readonly readaptacaoService: ReadaptacaoService,
  ) { }

  ngOnInit(): void {
    this.removerRedapatacaoDoMenu();
    this.usuarioSession = this.storageService.getFromLocalStorage('usuario', true);
    // MENU OCULTADO PARA ENTREGA 113
    // this.setReadaptacaoOnMenu();
  }

  get ambienteQA() {
    return window.location.href.includes('codatahml');
  }

  get anoLetivo(){
    return this.storageService.getFromLocalStorage('anoLetivo', true).ano;
  }

  get matricula(){
    return this.authService.getCurrentMatriculaNomeEscola().matricula;
  }

  clearAllFilters(): void {
    this.filterStateService.clearAllFilters();
  }

  private setReadaptacaoOnMenu(): void {
    if (Number(this.anoLetivo) >= 2025) {
      const params = new URLSearchParams();
      params.append('matricula', this.matricula);
      this.readaptacaoService.existeReadaptacaoVinculada(params).subscribe((existe) => {
        if (existe) {
          if (this.menus.findIndex(menu => menu.url === 'readaptacao') === -1) {
            this.menus.push({
              url: 'readaptacao',
              label: 'Readaptação'
            });
          }
        } else {
          this.removerRedapatacaoDoMenu();
        }
      });
    } else {
      this.removerRedapatacaoDoMenu();
    }
  }

  private removerRedapatacaoDoMenu(): void {
    this.menus = this.menus.filter(menu => menu.url !== 'readaptacao');
  }
}
